/**
 * Google Analytics Component
 * 
 * Injects Google Analytics and Google Tag Manager scripts
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '@/services/analyticsService';

export const GoogleAnalytics = () => {
  const location = useLocation();
  const isConfigured = analyticsService.isAnalyticsConfigured();

  useEffect(() => {
    if (!isConfigured) {
      return;
    }

    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID || import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
    const gtmId = import.meta.env.VITE_GTM_ID;

    // Initialize Google Analytics 4 (gtag.js)
    if (gaId && !window.gtag) {
      // Load gtag.js script
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script1);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function(...args: any[]) {
        window.dataLayer.push(args);
      };
      window.gtag('js', new Date());
      window.gtag('config', gaId, {
        page_path: location.pathname,
      });
    }

    // Initialize Google Tag Manager
    if (gtmId && !document.getElementById('gtm-script')) {
      // GTM script
      const gtmScript = document.createElement('script');
      gtmScript.id = 'gtm-script';
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(gtmScript);

      // GTM noscript
      const gtmNoscript = document.createElement('noscript');
      gtmNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(gtmNoscript, document.body.firstChild);
    }
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (isConfigured) {
      analyticsService.trackPageView(location.pathname, document.title);
    }
  }, [location.pathname, isConfigured]);

  return null;
};

